import { Injectable } from '@angular/core';
import { User } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  private readonly userKey = 'user';
  private readonly impersonatedUserKey = 'impersonatedUser';

  constructor() { }

  get storage() {
    return localStorage;
  }

  // This doesn't clear impersonation data because this may run on failed requests. We don't want to clear impersonation
  // info if a request fails.
  clearStorage() {
    this.storage.removeItem(this.userKey);
    this.storage.removeItem(this.impersonatedUserKey);
  }

  saveUser(user: User) {
    this.storage.removeItem(this.userKey);
    this.storage.setItem(this.userKey, JSON.stringify(user));
  }

  getUser(): User | null {
    const key = this.storage.getItem(this.userKey);
    if(key)
    {
      return JSON.parse(key);
    }
    else
    {
      return null;
    }
  }

  isImpersonating(): boolean {
    const token = this.storage.getItem(this.impersonatedUserKey);
    return !!token;
  }

  setImpersonating(user: User | null) {
    this.storage.removeItem(this.impersonatedUserKey);
    if(user) {
      this.storage.setItem(this.impersonatedUserKey, JSON.stringify(user));
    }
  }

  getImpersonatedUser(): User | null {
    const user = this.storage.getItem(this.impersonatedUserKey);
    return !user ? null : JSON.parse(user);
  }

  getEffectiveUser(): User | null {
    return this.isImpersonating() ? this.getImpersonatedUser() : this.getUser();
  }
}
